import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/ApproveAutoManagedPayout.graphql';
import { Mutation, MutationapproveAutoManagedPayoutArgs } from '../../__generated__/globalTypes';

export const useApproveAutoManagedPayoutMutation = (
  options?: MutationHookOptions<Mutation, MutationapproveAutoManagedPayoutArgs>
) => {
  const [callApproveAutoManagedPayout, result] = useMutation<Mutation, MutationapproveAutoManagedPayoutArgs>(
    MUTATION,
    options
  );

  return { callApproveAutoManagedPayout, ...result };
};

export type ApproveAutoManagedPayoutMutationFunction = Mutation['approveAutoManagedPayout'];
